import React, { lazy, Suspense } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { RouteSeo } from "./lib/seo";
import { Toaster } from "./components/ui/sonner";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import Layout from "./components/site/Layout";
import { Hero, Systems } from "./components/site/HeroSystems";
import { HomeTools } from "./components/site/HomeTools";
import Shop from "./components/site/Shop";
import QuoteSection from "./components/site/QuoteSection";
import { Gestionali } from "./components/site/Sections";
const Assistenza = lazy(() => import("./pages/Assistenza"));
const NotFound = lazy(() => import("./pages/NotFound"));
const ChiSiamo = lazy(() => import("./pages/ChiSiamo"));
const AreaClienti = lazy(() => import("./pages/AreaClienti"));
const Admin = lazy(() => import("./pages/Admin"));
import AuthCallback from "./pages/AuthCallback";
const TechApp = lazy(() => import("./pages/TechApp"));
const Legal = lazy(() => import("./pages/Legal"));
const Recensione = lazy(() => import("./pages/Recensione"));
const Macchina = lazy(() => import("./pages/Macchina"));
const FirmaContratto = lazy(() => import("./pages/FirmaContratto"));
const Proposta = lazy(() => import("./pages/Proposta"));
const ClienteQr = lazy(() => import("./pages/ClienteQr"));
const VerificazioniRT = lazy(() => import("./pages/VerificazioniRT"));
const Software = lazy(() => import("./pages/Software"));
const SoftwareDetail = lazy(() => import("./pages/SoftwareDetail"));
const SoftwareCompare = lazy(() => import("./pages/SoftwareCompare"));
const HardwareCategory = lazy(() => import("./pages/HardwareCategory"));
const Negozio = lazy(() => import("./pages/Negozio"));
const Marca = lazy(() => import("./pages/Marca"));
const GuidaScelta = lazy(() => import("./pages/GuidaScelta"));
const Noleggio = lazy(() => import("./pages/Noleggio"));
const EasyNoleggio = lazy(() => import("./pages/EasyNoleggio"));
const RentalContractSign = lazy(() => import("./pages/RentalContractSign"));
const RenewalConfirm = lazy(() => import("./pages/RenewalConfirm"));
const PaymentSuccess = lazy(() => import("./pages/Payment").then((m) => ({ default: m.PaymentSuccess })));
const PaymentCancel = lazy(() => import("./pages/Payment").then((m) => ({ default: m.PaymentCancel })));
import { GuideBanner, FinancingSection } from "./components/site/Promo";
import ReviewsShowcase from "./components/site/ReviewsShowcase";
import { EasyNoleggioSection } from "./components/site/EasyNoleggio";

const ToTech = () => { const { search } = useLocation(); return <Navigate to={`/tecnici${search}`} replace />; };

const Home = () => (
  <>
    <Hero />
    <HomeTools />
    <GuideBanner />
    <Systems />
    <Shop />
    <EasyNoleggioSection />
    <FinancingSection />
    <ReviewsShowcase />
    <Gestionali />
    <QuoteSection />
  </>
);

const AppRouter = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
    <RouteSeo />
    <Suspense fallback={<div className="min-h-[40vh] flex items-center justify-center" aria-busy="true"><span className="w-8 h-8 rounded-full border-[3px] border-[#CF1072] border-t-transparent animate-spin" /></div>}>
    <Routes>
      <Route path="/tecnici" element={<TechApp />} />
        <Route path="/kappa" element={<ToTech />} />
        <Route path="/easylab26" element={<ToTech />} />
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/assistenza" element={<Assistenza />} />
        <Route path="/verificazioni-rt" element={<VerificazioniRT />} />
        <Route path="/chi-siamo" element={<ChiSiamo />} />
        <Route path="/area-clienti" element={<AreaClienti />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/legal/:slug" element={<Legal />} />
        <Route path="/recensione/:token" element={<Recensione />} />
        <Route path="/m/:token" element={<Macchina />} />
        <Route path="/c/:token" element={<ClienteQr />} />
        <Route path="/firma/:cid/:token" element={<FirmaContratto />} />
        <Route path="/proposta/:qid/:token" element={<Proposta />} />
        <Route path="/negozio" element={<Negozio />} />
        <Route path="/marca/:slug" element={<Marca />} />
        <Route path="/guida-scelta" element={<GuidaScelta />} />
        <Route path="/noleggio-finanziamenti" element={<Noleggio />} />
        <Route path="/easy-noleggio" element={<EasyNoleggio />} />
        <Route path="/contratto-noleggio/:token" element={<RentalContractSign />} />
        <Route path="/rinnovo-software/:token" element={<RenewalConfirm />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/software" element={<Software />} />
        <Route path="/software/confronta" element={<SoftwareCompare />} />
        <Route path="/soluzioni-fiscali" element={<HardwareCategory slug="soluzioni-fiscali" intro="Registratori telematici, RT touch screen e con pagamento integrato, server RT e stampanti fiscali Custom. Installazione, attivazione e verificazione periodica a cura di EasySistem." />} />
        <Route path="/pagamento-automatico" element={<HardwareCategory slug="pagamento-automatico" intro="Casse automatiche VNE: il cliente paga in contanti, la macchina riconosce i falsi e restituisce il resto. Zero ammanchi, più igiene e controllo remoto degli incassi." />} />
        <Route path="/prodotti/:slug" element={<SoftwareDetail />} />
        <Route path="/software/:slug" element={<SoftwareDetail />} />
        <Route path="/index.html" element={<Home />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
    </Suspense>
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <AppRouter />
            <Toaster position="top-center" richColors />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
